import "core-js/modules/es.array.push.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d2474132"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "overflow-x": "auto",
    "flex": "1",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "height": "40px",
    "align-items": "center"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, null, -1));
const _hoisted_5 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "overflow-y": "auto",
    "flex": "1"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "margin-top": "20px"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "105px",
    "min-width": "105px",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "end",
    "padding-right": "10px",
    "font-size": "18px",
    "color": "#777777"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, "Ongoing")], -1));
const _hoisted_8 = {
  style: {
    "display": "flex",
    "padding-left": "15px",
    "flex-wrap": "wrap",
    "border-left": "1px solid rgb(215, 212, 212)"
  }
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "activity-title-box"
};
const _hoisted_12 = {
  key: 0,
  class: "activity-title"
};
const _hoisted_13 = {
  class: "activity-title"
};
const _hoisted_14 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_15 = {
  class: "collapse-header"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "position": "absolute",
    "font-size": "18px",
    "color": "#777777"
  }
}, " Completed ", -1));
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "collapse-content"
};
const _hoisted_19 = {
  key: 0,
  class: "collapse-content-item-line"
};
const _hoisted_20 = {
  key: 1,
  style: {
    "flex": "1",
    "display": "flex",
    "padding-left": "15px",
    "flex-wrap": "wrap",
    "overflow-y": "auto"
  }
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "activity-title-box"
};
const _hoisted_24 = {
  class: "activity-title"
};
const _hoisted_25 = {
  class: "activity-title"
};
import { ref, reactive, onMounted, getCurrentInstance, h, nextTick, createVNode, watch } from "vue";
import util from "@/util/util";
import permission from "@/util/permission";
import { Modal, message, notification } from "ant-design-vue";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import ResizePane from "@/components/ResizePane.vue";
import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";


import { ElNotification } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
// 引入组件

export default {
  __name: 'ListInteraction',
  setup(__props) {
    const components = {
      DownCircleOutlined,
      PlusOutlined
    };
    const {
      proxy
    } = getCurrentInstance();
    const route = useRoute();
    const router = useRouter();
    const activityStatsYearRO = reactive({
      searchKeyword: null,
      activityStatsTypeId: null
    });
    const activityStatsData = reactive({
      ongoingItems: [],
      years: []
    });
    onMounted(async () => {
      await loadActivityStatsData();
    });
    const loadActivityStatsData = async () => {
      let activityStatsYear = await getActivityStatsYearRequest(activityStatsYearRO);
      if (activityStatsYear == null) {
        return;
      }
      activityStatsData.ongoingItems.length = 0;
      if (Array.isArray(activityStatsYear.ongoingItems)) {
        activityStatsData.ongoingItems.push(...activityStatsYear.ongoingItems);
      }
      activityStatsData.years.length = 0;
      if (Array.isArray(activityStatsYear.completedItems)) {
        for (let item of activityStatsYear.completedItems) {
          let year = item.activityStatsBegin.substring(0, 4);
          let findIndex = activityStatsData.years.findIndex(element => element.yearName == year + "");
          if (findIndex != -1) {
            let yearObject = activityStatsData.years[findIndex];
            yearObject.completedItems.push(item);
          } else {
            let yearObject = {
              yearName: year + "",
              completedItems: []
            };
            yearObject.completedItems.push(item);
            activityStatsData.years.push(yearObject);
          }
        }
      }
      activityStatsData.years.sort((a, b) => {
        // 对 yearName 进行比较，降序排序
        return b.yearName.localeCompare(a.yearName);
      });
      console.log(activityStatsData.years);
    };
    const getActivityStatsYearRequest = async activityStatsYearRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityStatsRequest.getActivityStatsYear(activityStatsYearRO).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const items = reactive([{
      title: "2024",
      content: "This is the content of Panel 1"
    }, {
      title: "2025",
      content: "This is the content of Panel 2"
    }, {
      title: "2026",
      content: "This is the content of Panel 3"
    }]);
    const collapseSize = reactive({});
    // var collapseTransition = false;

    const activeIndex = ref(0);
    const onStatsTypeChange = id => {
      activityStatsYearRO.activityStatsTypeId = id;
      loadActivityStatsData();
    };
    const onStatsSearch = () => {
      loadActivityStatsData();
    };
    const toggle = index => {
      if (index == activeIndex.value) {
        return;
      }
      // collapseTransition = true;
      activeIndex.value = index;
    };
    const onPaneSizeChange = (size, sign) => {
      // collapseTransition = false;
      if (!collapseSize[sign]) {
        collapseSize[sign] = {};
      }
      collapseSize[sign].width = size.width;
      collapseSize[sign].height = size.height;
      console.log(size, sign);
    };
    const getHeaderItemStyle = index => {
      if (!collapseSize[index]) {
        return;
      }
      let style = {};
      if (index <= activeIndex.value) {
        style.transform = `translateY(${index * 23 + 30}px)`;
      } else {
        style.transform = `translateY(${collapseSize[activeIndex.value].height - (items.length - index) * 23}px)`;
      }
      // if (collapseTransition) {
      style.transition = "transform 0.3s ease";
      // }
      return style;
    };
    const getContentItemStyle = index => {
      if (!collapseSize[index]) {
        return;
      }
      let style = {};
      if (index <= activeIndex.value) {
        style.transform = `translateY(0px)`;
      } else {
        style.transform = `translateY(${collapseSize[activeIndex.value].height - (items.length - index) * 23 + 12}px)`;
      }
      // if (index === activeIndex.value) {
      //   style.height = `${
      //     collapseSize[index].height - (items.length - 1 - index) * 23
      //   }px`;
      // }
      // if (collapseTransition) {
      style.transition = "transform 0.3s ease";
      // }
      return style;
    };
    const onCreateNew = () => {
      router.push({
        path: "/create-interaction/"
      });
    };
    const jumpReport = item => {
      router.push({
        path: "/report-interaction/" + item.activityStatsItemId
      });
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_a_space = _resolveComponent("a-space");
      const _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_unref(permission).havePermission('互动数据', '新建互动数据') ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        onClick: onCreateNew,
        style: {
          "margin-left": "120px"
        },
        class: "sts-button default"
      }, {
        default: _withCtx(() => [_createTextVNode("Create New")]),
        _: 1
      })) : _createCommentVNode("", true), _hoisted_4, _createVNode(_component_a_space, {
        size: "large"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass([{
            active: activityStatsYearRO.activityStatsTypeId === null
          }, "filter-button"]),
          onClick: _cache[0] || (_cache[0] = $event => onStatsTypeChange(null))
        }, " All ", 2), _createElementVNode("div", {
          class: _normalizeClass([{
            active: activityStatsYearRO.activityStatsTypeId === 1
          }, "filter-button"]),
          onClick: _cache[1] || (_cache[1] = $event => onStatsTypeChange(1))
        }, " 365 ", 2), _createElementVNode("div", {
          class: _normalizeClass([{
            active: activityStatsYearRO.activityStatsTypeId === 2
          }, "filter-button"]),
          onClick: _cache[2] || (_cache[2] = $event => onStatsTypeChange(2))
        }, " Campaign ", 2), _createVNode(_component_a_input_search, {
          value: activityStatsYearRO.searchKeyword,
          "onUpdate:value": _cache[3] || (_cache[3] = $event => activityStatsYearRO.searchKeyword = $event),
          placeholder: "input search text",
          style: {
            "width": "200px"
          },
          onSearch: onStatsSearch
        }, null, 8, ["value"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsData.ongoingItems, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          style: _normalizeStyle({
            cursor: _unref(permission).havePermission('互动数据', '查看数据报告') || _unref(permission).havePermission('互动数据', '查看数据摘要') ? 'pointer' : ''
          }),
          class: "activity-box",
          onClick: $event => (_unref(permission).havePermission('互动数据', '查看数据报告') || _unref(permission).havePermission('互动数据', '查看数据摘要')) && jumpReport(item)
        }, [item.activityStatsTypeId === 1 ? (_openBlock(), _createBlock(_component_svg_icon, {
          key: 0,
          iconName: "365",
          iconSize: "60px",
          style: {
            "position": "absolute",
            "top": "0px",
            "right": "0px"
          }
        })) : _createCommentVNode("", true), _createElementVNode("img", {
          src: item.url != null ? item.url : require('@/assets/img/activityCoverDefault.png')
        }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [item.itemNameOnly !== true ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.activityStatsWeekName) + _toDisplayString(item.activityStatsTypeId === 1 ? "" : (item.activityStatsYear + "").substring(2, 4)) + " " + _toDisplayString(item.activityStatsItemName), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, _toDisplayString(item.activityStatsName), 1)])], 12, _hoisted_9);
      }), 128))])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsData.years, (year, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["collapse-header-item", {
            'active-header-item': index === activeIndex.value
          }]),
          style: _normalizeStyle(getHeaderItemStyle(index)),
          onClick: $event => toggle(index)
        }, _toDisplayString(year.yearName), 15, _hoisted_17);
      }), 128))]), _createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsData.years, (year, index) => {
        return _openBlock(), _createBlock(ResizePane, {
          sign: index,
          onPaneSizeChange: onPaneSizeChange,
          key: index,
          class: _normalizeClass([{
            active: index > activeIndex.value
          }, "collapse-content-item"]),
          style: _normalizeStyle(getContentItemStyle(index))
        }, {
          default: _withCtx(() => [index > activeIndex.value ? (_openBlock(), _createElementBlock("div", _hoisted_19)) : _createCommentVNode("", true), index === activeIndex.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(year.completedItems, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "activity-box",
              style: _normalizeStyle({
                cursor: _unref(permission).havePermission('互动数据', '查看数据报告') || _unref(permission).havePermission('互动数据', '查看数据摘要') ? 'pointer' : ''
              }),
              onClick: $event => (_unref(permission).havePermission('互动数据', '查看数据报告') || _unref(permission).havePermission('互动数据', '查看数据摘要')) && jumpReport(item)
            }, [item.activityStatsTypeId === 1 ? (_openBlock(), _createBlock(_component_svg_icon, {
              key: 0,
              iconName: "365",
              iconSize: "60px",
              style: {
                "position": "absolute",
                "top": "0px",
                "right": "0px"
              }
            })) : _createCommentVNode("", true), _createElementVNode("img", {
              src: item.url != null ? item.url : require('@/assets/img/activityCoverDefault.png')
            }, null, 8, _hoisted_22), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(item.activityStatsWeekName) + _toDisplayString(item.activityStatsTypeId === 1 ? "" : (item.activityStatsYear + "").substring(2, 4)) + " " + _toDisplayString(item.activityStatsItemName), 1), _createElementVNode("div", _hoisted_25, _toDisplayString(item.activityStatsName), 1)])], 12, _hoisted_21);
          }), 128))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityStatsData.years.length - 1 - index, (box, index1) => {
            return _openBlock(), _createElementBlock("div", {
              key: index1,
              style: {
                "width": "1",
                "height": "23px"
              }
            });
          }), 128))]),
          _: 2
        }, 1032, ["sign", "class", "style"]);
      }), 128))])])])])]);
    };
  }
};